import { PropsWithChildren, SVGAttributes, useId } from 'react'
import { cn } from '../utils/classnames'
import { useTranslation } from 'react-i18next'

export interface LoadingIndicatorProps extends SVGAttributes<SVGElement> {
  size?: 'xs' | 's' | 'm' | 'l' | 'xl'
  'data-testid'?: string
}

export default function LoadingIndicator({
  size,
  className,
  'data-testid': testId = 'default',
  ...props
}: PropsWithChildren<LoadingIndicatorProps>) {
  const { t } = useTranslation('ui-common')
  const svgTitleId = useId()

  return (
    <svg
      className={cn(
        'elm-loadingindicator',
        className,
        'text-red-500 dark:text-red-400'
      )}
      viewBox="0 0 44 44"
      aria-labelledby={`loading-indicator-${svgTitleId}`}
      role="img"
      data-size={size}
      data-testid={`${testId}-svg`}
      {...props}
    >
      <title
        id={`loading-indicator-${svgTitleId}`}
        data-testid={`${testId}-title`}
      >
        {t('loading')}
      </title>
      <circle
        className="elm-loadingindicator__circle"
        cx="22"
        cy="22"
        r="20"
        fill="none"
        strokeMiterlimit="10"
        data-testid={`${testId}-circle`}
      />
    </svg>
  )
}
